<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-body">
            <div class="row" style="margin-top: 30px;">
              <div class="col-md-12" style="padding: 0;">
                <h4><i class="fa fa-calendar"></i>
                  {{ $t('message.calendar.title') }} {{ moment(date).format('MMMM YYYY') }}
                </h4>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" style="padding: 0;">
                <div class="btn-group float-right" role="group" aria-label="Basic example">
                  <button type="button"
                          class="btn btn-sm btn-primary"
                          @click="getCalendar(moment(date).add(-1, 'months').format('YYYY-MM-DD'))">
                    <i class="fa fa-chevron-left"></i>
                  </button>
                  <button type="button"
                          class="btn btn-sm btn-primary"
                          @click="getCalendar(moment(date).add(1, 'months').format('YYYY-MM-DD'))">
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <ul class="list list-unstyled seven-cols">
              <li class="well calendar-block listcol-xs-12 col-sm-12 col-md-1 col-lg-1 float-left"
                  v-for="(rows, indx) in calendars" :key="'cal_' + indx">
                <h4 :class="{'clear-fix': true, 'title': true, 'text-red': moment(indx).format('d') == 0 }">
                  <span>{{ moment(indx).format('dddd') }}</span>
                  <span>{{ moment(indx).format('D') }}</span>
                </h4>
                <span v-for="(row, index) in rows" class="calendar-block" :key="'span_' + index">
                  <div style="margin-bottom: 4px;">
                    <small>
                      <div v-if="row.place_name">
                        {{ row.place_name }}
                      </div>
                      <div v-else-if="row.host_place_name">
                        {{ row.host_place_name }}
                      </div>
                      <div>
                        <b>
                          <span style="color: #FF4081" v-if="row.host_id"><i class="fal fa-bed"></i>&nbsp;&nbsp;</span>
                          <span>
                            #{{ row.id }}
                          </span>
                        </b>
                      </div>
                      <div v-if="Number(row.status) == 2" class="text-success">
                        <div>
                          {{ moment(row.start_time).format('HH:mm') }} -
                          {{ moment(row.start_time).add(row.work_hour, 'hours').format('HH:mm') }}
                        </div>
                        <div>
                          {{ $t('message.calendar.status.already') }}
                        </div>
                      </div>
                      <div v-else-if="Number(row.paid_status) == 0" class="text-warning">
                        <div>
                          {{ moment(row.start_time).format('HH:mm') }} -
                          {{ moment(row.start_time).add(row.work_hour, 'hours').format('HH:mm') }}
                        </div>
                        <div>
                          {{ $t('message.calendar.status.wait_for_payment') }}
                        </div>
                      </div>
                      <div v-else-if="Number(row.status) == 0" class="text-warning">
                        <div>
                          {{ moment(row.start_time).format('HH:mm') }} -
                          {{ moment(row.start_time).add(row.work_hour, 'hours').format('HH:mm') }}
                        </div>
                        <div>
                          {{$t('message.calendar.status.wait_professional_response') }}
                        </div>
                      </div>
                      <div v-else>
                        {{ moment(row.start_time).format('HH:mm') }} -
                        {{ moment(row.start_time).add(row.work_hour, 'hours').format('HH:mm') }}
                      </div>
                    </small>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'calendar',
    data () {
      return {
        calendars: [],
        year: moment().format('YYYY'),
        month: moment().format('MM'),
        date: moment().format('YYYY-MM-DD')
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    methods: {
      moment: function (date) {
        return moment(date)
      },
      async getCalendar (date = null) {
        this.$swal.showLoading()
        if (!this.$route.params.id) {
          return
        }
        let params = {}
        let url = `users/${this.$route.params.id}/calendar`
        if (date) {
          params.year = moment(date).format('YYYY')
          params.month = moment(date).format('MM')
          this.year = moment(date).format('YYYY')
          this.month = moment(date).format('MM')
          this.date = moment(date).format('YYYY-MM-DD')
        }
        if (this.$route.query.validation) {
          params.validation = this.$route.query.validation
        }

        let { data } = await axios.get(url, { params })
        if (!data.error) {
          this.calendars = data.data
        } else {
          alert(`Error: ${data.message}`)
        }
        this.$swal.close()
      }
    },
    created () {
      this.getCalendar()
    }
  }
</script>

<style scoped lang="scss">
  .calendar-block {
    height: 160px;
    overflow: auto;
  }

  .calendar-block .text-red {
    color: red;
  }

  .calendar-block .title {
    width: 100%;
    display: inline-block;
    padding-bottom: 4px;
    text-align: right;
    border-bottom: 1px solid #d0d0d0;
  }

  .calendar-block .text-blue {
    color: #46b7df;
  }

  .calendar-block .text-green {
    color: #59b122;
  }


  .well {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
  }


  @media (min-width: 992px) {
    .seven-cols .col-md-1,
    .seven-cols .col-sm-1,
    .seven-cols .col-lg-1 {
      max-width: 14.285714285714285714285714285714%;
      *max-width: 14.285714285714285714285714285714%;
    }
  }

  /**
   *  The following is not really needed in this case
   *  Only to demonstrate the usage of @media for large screens
   */
  @media (min-width: 1200px) {
    .seven-cols .col-md-1,
    .seven-cols .col-sm-1,
    .seven-cols .col-lg-1 {
      max-width: 14.285714285714285714285714285714%;
      *max-width: 14.285714285714285714285714285714%;
    }
  }


  @media(max-width: 992px) {

    .calendar-block {
      height: 80px;
      overflow: auto;
    }

    .seven-cols .col-md-1,
    .seven-cols .col-sm-1,
    .seven-cols .col-lg-1 {
      max-width: 14.285714285714285714285714285714%;
      *max-width: 14.285714285714285714285714285714%;
    }

    .seven-cols li.well {
      padding: 5px;
      font-size: 6px;
    }

    div.btn-group {
      margin-bottom: 20px;

      button {
        font-size: 12px;
      }
    }

    div.main-section {
      width: auto;
    }

    div.mCustomScrollbar.mCustomScrollbar {
      padding: 0;
    }

    .left-section .chatList .desc {
      .time {
        position: static;
      }

      width: auto;
    }


    div.message ul li.msg-right {
      small {
        margin-top: 23px;
      }

      .msg-desc {
        margin-right: 0;
        white-space: nowrap;
      }
    }

    li.calendar-block {
      min-height: 80px;
      overflow: scroll;
      font-size: 12px;

      h4.title {
        font-size: 6px;
      }

    }

  }

  .calendar-block {
    height: 160px;
    overflow: auto;
  }

  .calendar-block .text-red {
    color: red;
  }

  .calendar-block .title {
    width: 100%;
    display: inline-block;
    padding-bottom: 4px;
    text-align: right;
    border-bottom: 1px solid #d0d0d0;
  }

  .calendar-block .text-blue {
    color: #46b7df;
  }

  .calendar-block .text-green {
    color: #59b122;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Calendar.vue